import CloseIcon from '@mui/icons-material/Close';
import { Box, Drawer, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';

interface DrawerTemplateProps {
    open?: boolean;
    handleOnClose: () => void;
    title: string;
    description?: string;
    footer?: React.ReactNode;
    titleNodes?: React.ReactNode;
    width?: string | number;
    anchor?: 'right' | 'left' | 'top' | 'bottom' | undefined;
    children: React.ReactNode;
}

export const DrawerCommon: React.FC<DrawerTemplateProps> = ({
    handleOnClose,
    open,
    title,
    description,
    titleNodes,
    footer,
    width,
    anchor = 'right',
    children,
}) => {
    return (
        <Drawer
            open={open}
            anchor={anchor}
            onClose={handleOnClose}
            PaperProps={{
                sx: {
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    width: width,
                    maxWidth: '95vw',
                },
            }}
        >
            <Stack
                p={2}
                spacing={2}
                sx={theme => {
                    return {
                        backgroundColor: theme.palette?.appHeader?.main,
                        color: theme.palette?.appHeader?.contrastText,
                        '& .MuiIconButton-root': {
                            color: theme.palette?.appHeader?.contrastText,
                        },
                    };
                }}
            >
                <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Stack direction="row" spacing={2} alignItems="center">
                        <Typography variant="h6">{title}</Typography>
                        {titleNodes && titleNodes}
                    </Stack>
                    <IconButton onClick={handleOnClose}>
                        <CloseIcon />
                    </IconButton>
                </Stack>
                {description && <Typography variant="body2">{description}</Typography>}
            </Stack>
            <Box
                sx={{
                    flex: 1,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                }}
            >
                {children}
            </Box>
            {footer && <Box>{footer}</Box>}
        </Drawer>
    );
};
